import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

import { AssignmentSections } from '../enums';
import AssignmentsSection from '../AssignmentsSection';
import DraftAssignmentsSection from '../DraftAssignmentsSection';
import AssignmentTemplatesSection from '../AssignmentTemplatesSection';
import PartnerAssignmentsSection from '../PartnerAssignmentsSection';
import {
  isAdminSelector,
  isRecruiterCompanySelector,
} from 'redux/selectors/authenticationSelectors';
import useQueryMatch from 'hooks/useQueryMatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { AssignmentStatusTypeEnum } from 'api/adminApiClient';

const DEFAULT_SECTION = AssignmentSections.AllAssignments;

const SECTION_FOR_CORP_TA = [
  AssignmentSections.AllAssignments,
  AssignmentSections.Drafts,
  AssignmentSections.Templates,
];

const getPageSections = (isAdmin?: boolean, isRecruiterCompany?: boolean) => {
  if (isRecruiterCompany) {
    return Object.values(AssignmentSections);
  }

  if (!isAdmin) {
    return SECTION_FOR_CORP_TA;
  }

  return [DEFAULT_SECTION];
};

export default function AssignmentsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const query = queryString.parse(location.search);
  const isAdmin = useAppSelector(isAdminSelector);
  const isRecruiterCompany = useAppSelector(isRecruiterCompanySelector);
  const pageSectionMatch = useQueryMatch(
    getPageSections(isAdmin, isRecruiterCompany),
  );

  useEffect(() => {
    if (!pageSectionMatch) {
      navigate(`${location.pathname}?section=${DEFAULT_SECTION}`, {
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSectionMatch]);

  const getSection = () => {
    if (isAdmin) {
      switch (query.section) {
        case AssignmentSections.AllAssignments:
        default:
          return (
            <AssignmentsSection
              isAdmin={isAdmin}
              key={AssignmentStatusTypeEnum.Active}
            />
          );
      }
    }

    if (isRecruiterCompany) {
      switch (query.section) {
        case AssignmentSections.Partner:
          return <PartnerAssignmentsSection />;
      }
    }

    switch (query.section) {
      case AssignmentSections.Templates:
        return <AssignmentTemplatesSection />;

      case AssignmentSections.Drafts:
        return <DraftAssignmentsSection isAdmin={isAdmin} />;

      case AssignmentSections.AllAssignments:
      default:
        return (
          <AssignmentsSection
            key={AssignmentStatusTypeEnum.Active}
            isAdmin={isAdmin}
          />
        );
    }
  };

  return <>{getSection()}</>;
}
